module.exports = __webpack_public_path__ + "img/quality-reward-punishment.53dccd81.png";